import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseReorderPrivateCompanyLeadSpecialFees {
  privateCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useReorderPrivateCompanyLeadSpecialFees = ({
  privateCompanyLeadId,
  onSuccess,
  onError,
}: UseReorderPrivateCompanyLeadSpecialFees) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reorderPrivateCompanyLeadSpecialFees'],
    mutationFn: async (entries: { id: string; execution_priority: number }[]) => {
      const private_company_lead = {
        fee_rule_attributes: {
          special_entries_attributes: entries,
        },
      }

      await privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
